import style from './TableSamples.module.css';

import outSVG from 'assets/svg/sm_out-01.svg';

import React from 'react';
import { useDrag } from 'react-dnd';
import { address_server_short, PUBLIC_ASSETS } from 'config';
import { Store } from 'store/context/Store';
import { deleteSample } from 'services/sample.services';
import { modalStore } from 'store/mobx/modal.store';
import { SampleSourceStore } from 'store/context/SampleSourceStore';
import { ChildrenSampleStore } from 'store/context/ChildrenSampleStore';
import { observer } from 'mobx-react-lite';
import { storageStore } from 'store/mobx/storage.store';
import useAlert from 'hooks/useAlert';
import classNames from 'classnames';

const Item = observer((props) => {
  const { packId, line, column, storageId, sampleId, cell, mode } = props;

  const {
    selectedSamplesForCopy,
    setSelectedSamplesForCopy,
    deleteSelectedSamplesForCopy,
    refreshSamples,
  } = storageStore;

  const rules = mode?.rules ?? {};
  const sampleSourceStore = React.useContext(SampleSourceStore);
  const storeContext = React.useContext(Store);
  const { setSelectedTreeSample } = React.useContext(ChildrenSampleStore);

  const { showAlert } = useAlert();

  const { deleteSampleInPackById, loadSampleById, selectedSample } = storeContext;

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'sample',
    item: {
      packId: packId,
      storageId: storageId,
      sampleId: sampleId,
      line: line,
      column: column,
      value: cell.value.volume,
    },
    collect: (monitor) => ({ isDragging: !!monitor.isDragging() }),
  }));

  const onDelete = async () => {
    const deleteItem = async () => {
      let res = await deleteSample(sampleId);
      if (res.success) {
        deleteSampleInPackById(packId, sampleId);
        await refreshSamples();
      } else {
        showAlert('Возникла ошибка при попытке удалить образец!', 'error');
      }
    };
    showAlert('Вы действительно хотите удалить образец?', 'sure', deleteItem);
  };

  const onLoadSample = async () => {
    await loadSampleById(sampleId);
  };

  const onEdit = async () => {
    await onLoadSample();
    modalStore.openModal('sampleEdit', { mode, storeContext }, true);
  };

  const onView = async (e) => {
    if (e.ctrlKey) {
      if (!rules?.sample?.move) return;

      if (elementForCopyMode()) {
        deleteSelectedSamplesForCopy(sampleId);
      } else {
        setSelectedSamplesForCopy(sampleId);
      }
    } else {
      if (!rules?.sample?.get_info) return;
      await onLoadSample();
      modalStore.openModal(
        'sampleView',
        {
          mode,
          setSelectedTreeSample,
          storeContext,
          sampleSourceStore,
        },
        true,
      );
    }
  };

  const elementForCopyMode = () => {
    return selectedSamplesForCopy.some((i) => i === sampleId);
  };

  return (
    <div className={style.table_item_block_body}>
      <div className={style.table_item_block}>
        <div
          className={style.table_item}
          ref={rules?.sample?.move ? drag : null}
          style={{
            opacity: isDragging || elementForCopyMode() ? 0.3 : 1,
            borderColor:
              cell?.value?.id == selectedSample?.id
                ? '#0d6efd'
                : elementForCopyMode()
                  ? '#01b454'
                  : '#738087',
          }}
          onClick={onView}
        >
          <img
            src={address_server_short + PUBLIC_ASSETS + cell.value.icon}
            className={classNames(style.table_item_img, {
              [style.extracted]: cell.status == 'extracted',
            })}
          />
          {cell.status == 'extracted' && (
            <img
              src={outSVG}
              className={classNames(style.table_item_img, style.image_extracted)}
            ></img>
          )}

          {!cell.value.icon && (
            <div className={style.table_item_add_block}>
              <div className={style.table_item_add}></div>
            </div>
          )}
        </div>
        {cell.value.icon &&
          !isDragging &&
          !elementForCopyMode() &&
          cell.status != 'extracted' &&
          rules?.sample?.delete && (
            <div className={style.table_item_delete} onClick={onDelete}>
              <div className={style.table_item_delete_svg}></div>
            </div>
          )}
        {cell.value.icon &&
          !isDragging &&
          !elementForCopyMode() &&
          cell.status != 'extracted' &&
          rules?.sample?.upsert && (
            <div className={style.table_item_edit} onClick={onEdit}>
              <div className={style.table_item_edit_svg}></div>
            </div>
          )}
      </div>
      <div className={classNames(style.table_item, style.table_item_ghost)}></div>
    </div>
  );
});

export default Item;
